"use client"

import React from "react"
import { usePathname } from "next/navigation"
import { generateBreadcrumbItems } from "@/utils/breadcrumb"

import { Breadcrumb } from "@shared/ui"

import { Sidebar } from "./_components/sidebar"

export default function DashboardLayout({
  children,
}: {
  children: React.ReactNode
}) {
  const pathname = usePathname()
  const breadcrumbItems = generateBreadcrumbItems(pathname)

  return (
    <main className="flex h-screen w-screen overflow-hidden">
      <Sidebar />
      <div className="flex flex-1 flex-col ">
        <div className="px-8 pt-8">
          <Breadcrumb
            items={breadcrumbItems}
            className="mb-5"
            homeHref="/modules"
            currentPath={pathname}
          />
        </div>
        <div className="flex-1 overflow-auto">{children}</div>
        <footer className="flex justify-center px-8 pb-3 pt-2">
          <p className="text-center text-xs font-normal leading-normal text-[#576272]">
            DeepForge By Instadeep
          </p>
        </footer>
      </div>
    </main>
  )
}
